import React from 'react';

import { styled } from '@mui/material/styles';
import { Color } from '../../theme';
import { Card } from '../components/Card';
import ConcreteMixerIcon from '../components/ConcreteMixerIcon';
import Icon from '../components/Icon';

import {
  faWandMagicSparkles,
  faMound,
} from '@fortawesome/free-solid-svg-icons';

type Props = {
  className?: string;
};

const Container = styled('section')`
  .cards {
    display: flex;
    gap: ${(p) => p.theme.spacing(3)};
    margin-top: ${(p) => p.theme.spacing(5)};

    .media {
      height: 72px;
    }
  }

  .long-copy {
    margin-bottom: ${(p) => p.theme.spacing(7)};
  }
`;

const StyledIcon = styled(Icon)`
  color: ${Color.red};
  display: block;
  font-size: 3rem;
  margin-bottom: 10px;
`;

const Products = ({ className }: Props) => (
  <Container className={className} id='products'>
    <div className='row'>
      <h2>Products</h2>
      <div className='cards'>
        <Card
          media={<ConcreteMixerIcon />}
          content={
            <p>
              Concrete mixes starting at 3,000 PSI and above
            </p>
          }
        />
        <Card
          media={<StyledIcon icon={faMound} />}
          content={
            <p>
              Straight cement mixes and fly ash mixes available
            </p>
          }
        />
        <Card
          media={<StyledIcon icon={faWandMagicSparkles} />}
          content={
            <p>
              Gap-graded mix option for improved workability and finisher satisfaction
              <br /><br />
              <small>
                This mix is more workable at given slumps, has less segregation, and yields a more uniform surface appearance.
              </small>
            </p>
          }
        />
      </div>
    </div>
  </Container>
);

export default Products;

